"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeClasses = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _clsx = _interopRequireDefault(require("clsx"));
var _keys = _interopRequireDefault(require("../poly/keys"));
const mergeClasses = (baseClasses, customClasses) => {
  const allKeys = [...new Set([...(0, _keys.default)(baseClasses), ...(0, _keys.default)(customClasses)])];
  const classes = {};
  for (let key of allKeys) {
    classes[key] = (0, _clsx.default)((0, _get.default)(baseClasses, key), (0, _get.default)(customClasses, key));
  }
  return classes;
};
exports.mergeClasses = mergeClasses;